import * as Sentry from '@sentry/react'
import { browserTracingIntegration } from '@sentry/react'

export default function sentrySetup(dsn) {
  if (!dsn) {
    console.log('Skipping SENTRY because no DSN')
    return
  }
  Sentry.init({
    dsn,
    integrations: [browserTracingIntegration()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,

    beforeSend(event, hint) {
      const error = hint?.originalException

      // Skip noisy GTM errors
      if (error instanceof ReferenceError) {
        const msg = error.message || ''
        if (/braze/i.test(msg) || /\bAF\b/.test(msg)) {
          return null
        }
      }

      return event
    },
  })
}
